export default __webpack_public_path__ + "static/media/Bossonian Sovereign Ring.c2c76685.jpg";